
export const isAdmin = (user) => {
    return (user.roles && (user.roles.indexOf('admin') !== -1));
};



// WEBPACK FOOTER //
// ./src/helpers/index.js